<template>
    <div :class="getClasses()" @click="handleClick"></div>
</template>
<script>
    export default {
        name: 'Expand',
        props: ['expand'],
        methods: {
            getClasses() {
                return [
                    'select-expand',
                    {
                        [`select-expand-open`]: this.expand
                    }
                ]
            },
            handleClick() {
                this.$emit('input', !this.expand)
                this.$emit('click', !this.expand)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/business/select-member/tree/expand.vue